var map = {
	"./cart.js": 81,
	"./categories.js": 101,
	"./index.js": 6,
	"./order.js": 102,
	"./plugins/cartStorage.js": 17,
	"./products.js": 103,
	"./shop.js": 109
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;


//////////////////
// WEBPACK FOOTER
// ./client/store ^\.\/.*\.js$
// module id = 80
// module chunks = 35